import { render, staticRenderFns } from "./ExamResults.vue?vue&type=template&id=2a178488&scoped=true"
import script from "./ExamResults.vue?vue&type=script&lang=js"
export * from "./ExamResults.vue?vue&type=script&lang=js"
import style0 from "./ExamResults.vue?vue&type=style&index=0&id=2a178488&prod&scoped=true&lang=css"
import style1 from "./ExamResults.vue?vue&type=style&index=1&id=2a178488&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a178488",
  null
  
)

export default component.exports